// const window = require('global/window');
// eslint-disable-next-line import/no-extraneous-dependencies,import/no-unresolved
const FileZipIcon = require('@digital-hig/icon/lib/cjs/icons/file-zip').default;
// eslint-disable-next-line import/no-extraneous-dependencies,import/no-unresolved
const FileDocIcon = require('@digital-hig/icon/lib/cjs/icons/file-document').default;
// eslint-disable-next-line import/no-extraneous-dependencies,import/no-unresolved
const FilePDFIcon = require('@digital-hig/icon/lib/cjs/icons/file-pdf').default;
// eslint-disable-next-line import/no-extraneous-dependencies,import/no-unresolved
const FileGenericIcon = require('@digital-hig/icon/lib/cjs/icons/file-generic').default;

// eslint-disable-next-line import/no-extraneous-dependencies
const lightTheme = require('@digital-hig/theme-data/lib/build/json/light/design-tokens.json');

const modExports = {};
modExports.CLIENT_CONTEXT_CHANNEL = 'CLIENT_CONTEXT_CHANNEL';

modExports.LRS_APPID_LRNO = 'https://www.autodesk.com/learnone';
modExports.LRS_APPID_CSO = 'https://customersuccess.autodesk.com/';
modExports.LRS_APPID_AEX = 'https://www.autodesk.com/learn';
modExports.LRS_APPID_AU = 'https://www.autodesk.com/autodesk-university/';

modExports.APP_ACCOUNTS = 'APP_ACCOUNTS';
modExports.APP_PROFILE = 'APP_PROFILE';
modExports.LEARN_ONE_TARGET_VALUE = 'Learn ONE';
modExports.AEX_TARGET_VALUE = 'Learning and Certification';
modExports.CSO_TARGET_VALUE = 'Customer Success Hub';

modExports.API_TARGET_CHANNELS = JSON.stringify([modExports.LEARN_ONE_TARGET_VALUE, modExports.AEX_TARGET_VALUE, modExports.CSO_TARGET_VALUE]);

modExports.CLIENT_SOURCE_AEX = 'AEX';
modExports.CLIENT_SOURCE_CSO = 'CSO';
modExports.CLIENT_SOURCE_LRNO = 'LRNO';

modExports.SEGMENT_TREATMENT = 'Treatment';

modExports.ROUTER_BASENAME = 'ROUTER_BASENAME';

modExports.OXYGEN_REDIRECT_URL_KEY = 'autodesk_oxygen_redir_url';

modExports.LRS_VERB_COMPLETED = 'completed';
modExports.LRS_VERB_STARTED = 'started';
modExports.LRS_VERB_SEARCH = 'search';
modExports.LRS_VERB_FIND = 'find';
modExports.LRS_VERB_ACKNOWLEDGED = 'acknowledged';
modExports.LRS_VERB_CONSUMED = 'consumed';
modExports.LRS_VERB_VIEWED = 'viewed';
modExports.LRS_EXTENSIONS_CONTENTCHANGE = 'content change';
modExports.OBJECT_TYPE_PROBLEM = 'assessment';

modExports.LRS_CONTEXT_EXTENSIONS = 'extensions';
modExports.LRS_EXTENSIONS_PURPOSE = 'purpose';
modExports.LRS_EXTENSIONS_RETIRED = 'retired';

modExports.PRELOADED_STATE_KEY = '__PRELOADED_STATE__';

modExports.DEV_ENV = 'dev';
modExports.STAGE_ENV = 'stg';
modExports.PROD_ENV = 'prod';
modExports.PERF_ENV = 'perf';
modExports.MAINTENANCE_MODE = 'MAINTENANCE_MODE';

modExports.LOG_LEVEL = 'LOG_LEVEL';
modExports.LOG_LEVEL_DEBUG = 'debug';
modExports.LOG_LEVEL_INFO = 'info';
modExports.LOG_LEVEL_WARN = 'warn';
modExports.LOG_LEVEL_ERROR = 'error';

modExports.LOGGER_URL = 'LOGGER_URL';
modExports.ENVIRONMENT = 'ENVIRONMENT';
modExports.REQUEST_FLAGS = 'requestFlags';
modExports.IS_PREVIEW = 'isPreview';
modExports.COURSE_API_HOST = 'COURSE_API_HOST';
modExports.COURSE_PREVIEW_API_HOST = 'COURSE_PREVIEW_API_HOST';
modExports.COURSE_PREVIEW_REQUEST_HOST = 'COURSE_PREVIEW_REQUEST_HOST';
modExports.COURSE_DATA_HOST = 'CONTENTFUL_GRAPHQL_HOST';
modExports.LIST_API_HOST = 'LIST_API_HOST';
modExports.COACH_REQUEST_SERVICE_HOST = 'COACH_REQUEST_SERVICE_HOST';
modExports.COACH_REQUEST_SERVICE_HOST_PREVIEW = 'COACH_REQUEST_SERVICE_HOST_PREVIEW';
modExports.USE_MOCKS = 'useMocks';
modExports.SHARE_PREFIX = 'SHARE_PREFIX';
modExports.HOST = 'HOST';
modExports.CLARUS_LINK = 'CLARUS_LINK';
modExports.LL_PRODUCER_API = 'LL_PRODUCER_API';
modExports.LL_CONSUMER_API = 'LL_CONSUMER_API';
modExports.CERT_API = 'CERT_API';
modExports.SEARCH_API = 'SEARCH_API';
modExports.FILTER_API = 'FILTER_API';
modExports.CONTENTFUL_GRAPHQL_TOKEN = 'CONTENTFUL_GRAPHQL_TOKEN';
modExports.CONTENTFUL_PREVIEW_GRAPHQL_TOKEN = 'CONTENTFUL_PREVIEW_GRAPHQL_TOKEN';
modExports.CONTENTFUL_ENVIRONMENT_ID = 'CONTENTFUL_ENVIRONMENT_ID';
modExports.CONTENTFUL_SPACE_ID = 'CONTENTFUL_SPACE_ID';
modExports.HTML_MAX_AGE = 'HTML_MAX_AGE';
modExports.USER_PROFILE_API = 'USER_PROFILE_API';

modExports.QUIZ_TYPE_SINGLE = 'multiplechoice';
modExports.QUIZ_TYPE_MULTI = 'multiselect';
modExports.QUIZ_TYPE_ORDERING = 'ordering';
modExports.QUIZ_TYPE_MATCHING = 'matching';

modExports.LEARNING_MODE_COURSEWARE = 'courseware';
modExports.LEARNING_MODE_MICROLEARNING = 'microlearning';

modExports.LIST_ID_BOOKMARKS = 'bookmarks';
modExports.LIST_ID_FOLLOWED = 'followed';
modExports.LIST_TYPE_COURSE = 'COURSE';
modExports.LIST_TYPE_MODULE = 'MODULE';
modExports.LIST_TYPE_COLLECTION = 'COLLECTION';
modExports.LIST_TYPE_LIST = 'LIST';
modExports.LIST_TITLE_MAX = 25;
modExports.LIST_DESCRIPTION_MAX = 100;

modExports.CATALOG_QUERY_PARAM = 'catFilter';
modExports.CATALOG_CARD_LOADING = 'loading';
modExports.CATALOG_CARD_BLANK = 'blank';
modExports.CATALOG_CARD_ROW = 'rowView';
modExports.CATALOG_CARD_LIST_EDIT = 'listEdit';
modExports.CATALOG_CARD_LIST_DELETED = 'listDeleted';
modExports.MFE_CARD = 'mfeCard';

modExports.COMPONENT_CURATED = 'curated';
modExports.COMPONENT_COURSE = 'course';
modExports.COMPONENT_INDEX = 'index';
modExports.COMPONENT_NOTFOUND = 'notFound';
modExports.COMPONENT_DASHBOARD = 'dashboard';
modExports.COMPONENT_CATALOG = 'catalog';
modExports.COMPONENT_TUTORIAL = 'tutorial';
modExports.COMPONENT_CURATED_TUTORIAL = 'curatedTutorial';
modExports.COMPONENT_UNIT_WRAPPER = 'unitWrapper';
modExports.COMPONENT_MODULE_UNIT_WRAPPER = 'moduleUnitWrapper';
modExports.COMPONENT_LIST = 'list';
modExports.COMPONENT_COLLECTION = 'collection';
modExports.COMPONENT_LIVE_CLASS_ENROLLMENT = 'liveClassEnrollment';
modExports.COMPONENT_COACHING_REQUEST = 'coachingRequest';

modExports.PAGETYPE_TUTORIAL = 'tutorial';
modExports.PAGETYPE_MODULE = 'module';
modExports.PAGETYPE_CURATED = 'curated';
modExports.PAGETYPE_COURSE = 'course';
modExports.PAGETYPE_CATALOG = 'catalog';
modExports.PAGETYPE_COLLECTION = 'collection';
modExports.PAGETYPE_MODULE_UNIT = 'moduleUnit';
modExports.PAGETYPE_COURSE_UNIT = 'courseUnit';
modExports.PAGETYPE_COURSE_MODULE = 'courseModule';

modExports.MY_LEARNING = 'myLearning';
modExports.MY_LISTS = 'myLists';
modExports.MY_FOLLOWED_LISTS = 'myFollowedLists';
modExports.MY_BOOKMARKS = 'myBookmarks';
modExports.MY_CERTIFICATIONS = 'myCertifications';
modExports.COURSES_MODULES = 'coursesAndModules';
modExports.TUTORIALS_CURATEDS = 'tutorialsAndCurateds';
modExports.TUTORIALS_CURATEDLISTS = 'tutorialsAndCuratedLists';
modExports.COLLECTIONS = 'collections';

modExports.BANNER_TYPE_INFO = 'info';
modExports.BANNER_TYPE_SUCCESS = 'success';
modExports.BANNER_TYPE_WARNING = 'warning';
modExports.BANNER_TYPE_ERROR = 'error';

modExports.ITEM_TYPE_HTML = 'BlockHtml';
modExports.ITEM_TYPE_PDF = 'BlockPdf';
modExports.ITEM_TYPE_VIDEO = 'BlockVideo';
modExports.ITEM_TYPE_QUIZ = 'BlockProblem';

modExports.OBJECT_TYPE_UNIT = 'resource';
modExports.OBJECT_TYPE_PROBLEM = 'assessment';
modExports.OBJECT_TYPE_COURSE = 'course';
modExports.OBJECT_TYPE_MODULE = 'module';
modExports.OBJECT_TYPE_QUERY = 'query';
modExports.OBJECT_TYPE_COLLECTION = 'collection';

modExports.EDC_SLUG_INDEX_HEADER = 'learn-one-unified-index-page-title';
modExports.EDC_SLUG_INDEX_WAYFINDING_INTRO = 'learn-one-unified-wayfinding-intro';
modExports.EDC_SLUG_INDEX_WAYFINDING_BLOCK1 = 'learn-one-unified-wayfinding-block-1';
modExports.EDC_SLUG_INDEX_WAYFINDING_BLOCK2 = 'learn-one-unified-wayfinding-block-2';
modExports.EDC_SLUG_INDEX_WAYFINDING_BLOCK3 = 'learn-one-unified-wayfinding-block-3';
modExports.EDC_SLUG_INDEX_WAYFINDING_BLOCK4 = 'learn-one-unified-wayfinding-block-4';
modExports.EDC_SLUG_INDEX_SELECT_PRODUCT = 'learn-one-unified-select-product';
modExports.EDC_SLUG_INDEX_TUTORIALS = 'learn-one-unified-index-tutorials-and-curated-lists';
modExports.EDC_SLUG_INDEX_COURSES = 'learn-one-unified-index-courses-and-modules';
modExports.EDC_SLUG_INDEX_COLLECTIONS = 'learn-one-unified-index-collections';
modExports.EDC_SLUG_INDEX_INDUSTRY = 'learn-one-unified-index-industry-and-capabilities';
modExports.EDC_SLUG_INDEX_CERTIFICATIONS = 'learn-one-unified-index-certifications';
modExports.EDC_SLUG_INDEX_EDUCATORS = 'learn-one-unified-index-educators';
modExports.EDC_SLUG_INDEX_MORE_LEARNING_BLOCK1 = 'learn-one-unified-index-more-learning-block-1';
modExports.EDC_SLUG_INDEX_MORE_LEARNING_BLOCK2 = 'learn-one-unified-index-more-learning-block-2';
modExports.EDC_SLUG_ENROLLMENT_REQUEST_EN_US = 'learn-one-enrollment-index-request-dictionary';
modExports.EDC_SLUG_ENROLLMENT_REQUEST_ZH_CN = 'learn-one-enrollment-index-request-dictionary-zh-CN';
modExports.EDC_SLUG_ENROLLMENT_REQUEST_KO_KR = 'learn-one-enrollment-index-request-dictionary-ko-KR';
modExports.EDC_SLUG_ENROLLMENT_REQUEST_JA_JP = 'learn-one-enrollment-index-request-dictionary-ja-JP';
modExports.EDC_SLUG_ENROLLMENT_REQUEST_IT_IT = 'learn-one-enrollment-index-request-dictionary-it-IT';
modExports.EDC_SLUG_ENROLLMENT_REQUEST_FR_FR = 'learn-one-enrollment-index-request-dictionary-fr-FR';
modExports.EDC_SLUG_ENROLLMENT_REQUEST_ES_ES = 'learn-one-enrollment-index-request-dictionary-es-ES';
modExports.EDC_SLUG_ENROLLMENT_REQUEST_DE_DE = 'learn-one-enrollment-index-request-dictionary-de-DE';
modExports.EDC_SLUG_COACHINGREQUEST_WAYFINDING_INTRO = 'learn-one-coachrequest-wayfinding-intro';
modExports.EDC_SLUG_COACHINGREQUEST_WAYFINDING_BLOCK1 = 'learn-one-coachrequest-wayfinding-block-1';
modExports.EDC_SLUG_COACHINGREQUEST_WAYFINDING_BLOCK2 = 'learn-one-coachrequest-wayfinding-block-2';

// Personalized Constants
modExports.EDC_SLUG_PERSONALIZED_HEADER = 'learn-one-authenticated-index-page-title';
modExports.EDC_SLUG_PERSONALIZED_TUTORIALS = 'learn-one-authenticated-index-tutorials-and-curated-lists';
modExports.EDC_SLUG_PERSONALIZED_CERTIFICATIONS = 'index-page-certification';
modExports.EDC_SLUG_PERSONALIZED_EDUCATORS = 'learn-one-unified-index-educators';
modExports.EDC_SLUG_PERSONALIZED_COURSES = 'learn-one-authenticated-index-courses-and-modules';
modExports.EDC_SLUG_PERSONALIZED_COLLECTIONS = 'learn-one-authenticated-index-collections';
modExports.EDC_SLUG_PERSONALIZED_SELECT_PRODUCT = 'learn-one-authenticated-product-entitlement';
modExports.EDC_SLUG_PERSONALIZED_MORE_LEARNING_BLOCK1 = 'learn-one-unified-index-more-learning-block-1';
modExports.EDC_SLUG_PERSONALIZED_MORE_LEARNING_BLOCK2 = 'learn-one-unified-index-more-learning-block-2';
modExports.EDC_SLUGS_PERSONALIZED_NO_PRODUCT_SELECTED = 'learn-one-authenticated-no-product-entitlements';
modExports.EDC_SLUG_INDEX_SELECT_PRODUCT = 'learn-one-unified-select-product';

modExports.LEARN_LIVE_ENROLLMENT_HOST = 'LEARN_LIVE_ENROLLMENT_HOST';
modExports.LEARN_LIVE_COACHING_REQUEST_HOST = 'LEARN_LIVE_COACHING_REQUEST_HOST';

modExports.EDC_SLUG_CATALOG_INTRO = 'catalog-page-intro';

modExports.EDC_SLUGS_CATALOG = [modExports.EDC_SLUG_CATALOG_INTRO];

modExports.LOGIN_EXPERIMENT = 'LoginExperiment';
modExports.LOGIN_EXPERIMENT_SEGMENT1 = 'LoginExperimentSegment1';
modExports.LOGIN_EXPERIMENT_SEGMENT2 = 'LoginExperimentSegment2';

modExports.PERSONALIZATION_EXPERIMENT = 'PersonalizationExperiment';
modExports.PERSONALIZATION_EXPERIMENT_CONTROL = 'control';
modExports.PERSONALIZATION_EXPERIMENT_TREATMENT = 'treatment';
modExports.PERSONALIZATION_EXPERIMENT_ACTIVETRIALONLY = 'ActiveTrialOnly';
modExports.PERSONALIZATION_EXPERIMENT_ACTIVECOMMONLY = 'ActiveCommOnly';
modExports.PERSONALIZATION_EXPERIMENT_ACTIVETRIALANDCOMM = 'ActiveTrialAndComm';
modExports.PERSONALIZATION_EXPERIMENT_EXPIREDTRIALONLY = 'ExpiredTrialOnly';
modExports.PERSONALIZATION_EXPERIMENT_ATOTREATMENT = 'ATOTreatment';
modExports.PERSONALIZATION_EXPERIMENT_ACOTREATMENT = 'ACOTreatment';
modExports.PERSONALIZATION_EXPERIMENT_ATACTREATMENT = 'ATACTreatment';
modExports.PERSONALIZATION_EXPERIMENT_ATOCONTROL = 'ATOControl';
modExports.PERSONALIZATION_EXPERIMENT_ACOCONTROL = 'ACOControl';
modExports.PERSONALIZATION_EXPERIMENT_ATACCONTROL = 'ATACControl';
modExports.PERSONALIZATION_EXPERIMENT_ETOCONTROL = 'ETOControl';
modExports.PERSONALIZATION_EXPERIMENT_ETOTREATMENT = 'ETOTreatment';
modExports.PERSONALIZATION_EXPERIMENT_TRIAL_ENTITLEMENT = 'TRIAL';
modExports.PERSONALIZATION_EXPERIMENT_COMMERCIAL_ENTITLEMENT = 'COMMERCIAL';

modExports.EDC_SLUGS_INDEX = [
  modExports.EDC_SLUG_INDEX_HEADER,
  modExports.EDC_SLUG_INDEX_WAYFINDING_INTRO,
  modExports.EDC_SLUG_INDEX_WAYFINDING_BLOCK1,
  modExports.EDC_SLUG_INDEX_WAYFINDING_BLOCK2,
  modExports.EDC_SLUG_INDEX_WAYFINDING_BLOCK3,
  modExports.EDC_SLUG_INDEX_WAYFINDING_BLOCK4,
  modExports.EDC_SLUG_INDEX_SELECT_PRODUCT,
  modExports.EDC_SLUG_CATALOG_INTRO,
  modExports.EDC_SLUG_INDEX_TUTORIALS,
  modExports.EDC_SLUG_INDEX_COURSES,
  modExports.EDC_SLUG_INDEX_COLLECTIONS,
  modExports.EDC_SLUG_INDEX_INDUSTRY,
  modExports.EDC_SLUG_INDEX_CERTIFICATIONS,
  modExports.EDC_SLUG_INDEX_EDUCATORS,
  modExports.EDC_SLUG_INDEX_MORE_LEARNING_BLOCK1,
  modExports.EDC_SLUG_INDEX_MORE_LEARNING_BLOCK2,
];

modExports.EDC_SLUGS_PERSONALIZED = [
  modExports.EDC_SLUG_PERSONALIZED_HEADER,
  modExports.EDC_SLUG_PERSONALIZED_SELECT_PRODUCT,
  modExports.EDC_SLUGS_PERSONALIZED_NO_PRODUCT_SELECTED,
  modExports.EDC_SLUG_PERSONALIZED_TUTORIALS,
  modExports.EDC_SLUG_PERSONALIZED_COURSES,
  modExports.EDC_SLUG_PERSONALIZED_COLLECTIONS,
  modExports.EDC_SLUG_INDEX_INDUSTRY,
  modExports.EDC_SLUG_PERSONALIZED_CERTIFICATIONS,
  modExports.EDC_SLUG_PERSONALIZED_EDUCATORS,
  modExports.EDC_SLUG_PERSONALIZED_MORE_LEARNING_BLOCK1,
  modExports.EDC_SLUG_PERSONALIZED_MORE_LEARNING_BLOCK2,
  modExports.EDC_SLUG_INDEX_SELECT_PRODUCT,
];

modExports.EDC_SLUGS_ENROLLMENT_EN_US = [
  modExports.EDC_SLUG_ENROLLMENT_REQUEST_EN_US,
];

modExports.EDC_SLUGS_ENROLLMENT_ZH_CN = [
  modExports.EDC_SLUG_ENROLLMENT_REQUEST_ZH_CN,
];

modExports.EDC_SLUGS_ENROLLMENT_KO_KR = [
  modExports.EDC_SLUG_ENROLLMENT_REQUEST_KO_KR,
];

modExports.EDC_SLUGS_ENROLLMENT_JA_JP = [
  modExports.EDC_SLUG_ENROLLMENT_REQUEST_JA_JP,
];

modExports.EDC_SLUGS_ENROLLMENT_IT_IT = [
  modExports.EDC_SLUG_ENROLLMENT_REQUEST_IT_IT,
];

modExports.EDC_SLUGS_ENROLLMENT_FR_FR = [
  modExports.EDC_SLUG_ENROLLMENT_REQUEST_FR_FR,
];

modExports.EDC_SLUGS_ENROLLMENT_ES_ES = [
  modExports.EDC_SLUG_ENROLLMENT_REQUEST_ES_ES,
];

modExports.EDC_SLUGS_ENROLLMENT_DE_DE = [
  modExports.EDC_SLUG_ENROLLMENT_REQUEST_DE_DE,
];

modExports.VALID_AWS_ENVS = [modExports.DEV_ENV, modExports.STAGE_ENV, modExports.PROD_ENV, modExports.PERF_ENV];
modExports.VALID_LOG_LEVELS = [
  modExports.LOG_LEVEL_DEBUG,
  modExports.LOG_LEVEL_INFO,
  modExports.LOG_LEVEL_WARN,
  modExports.LOG_LEVEL_ERROR,
];

modExports.ERROR_TYPE_404 = '404';
modExports.ERROR_TYPE_XHR = 'XHR';
modExports.ERROR_TYPE_IFRAME = 'IFRAME';
modExports.ERROR_TYPE_BROWSER = 'BROWSER';
modExports.ERROR_TYPE_LIST_PERMISSION = 'LIST_PERMISSION';

modExports.AA_EVENT_START = 'start';
modExports.AA_EVENT_CONTINUE = 'continue';
modExports.AA_EVENT_COMPLETE = 'complete';
modExports.AA_EVENT_REVISIT = 'revisit';

modExports.AA_SESSION_KEY_COURSE_CONTINUE = 'LRNOASKCC';
modExports.AA_SESSION_KEY_COURSE_REVISIT = 'LRNOASKCR';
modExports.AA_SESSION_KEY_MODULE_CONTINUE = 'LRNOASKMC';
modExports.AA_SESSION_KEY_MODULE_REVISIT = 'LRNOASKMR';

modExports.LOCAL_STORAGE_LRS_KEY = 'LRNO.LearnOneRecords';
modExports.LOCAL_STORAGE_VIEW_COUNT_KEY = '_uavc';
modExports.LOCAL_STORAGE_ANONYMOUS_ID = 'anonymous';

modExports.UNAUTHMODAL_SHOWN = 'UNAUTHMODAL_SHOWN';

modExports.NAV_ITEMS = 'navItems';

modExports.RETRY_COUNT = 2;

modExports.SEARCH_ACTION_SEARCH = 'search';
modExports.SEARCH_ACTION_FILTER = 'filter';

modExports.SUCCESS_PROMISE_DELETED = 'deleted';
modExports.SUCCESS_PROMISE_CANCELLED = 'cancelled';

modExports.LIST_PERMISSIONS_PRIVATE = 'PRIVATE';
modExports.LIST_PERMISSIONS_UNLISTED = 'UNLISTED';
modExports.LIST_TITLE_MAX = 25;
modExports.LIST_DESCRIPTION_MAX = 300;

modExports.UGC_FILTER_KEY = 'UGC_FILTER_KEY';
modExports.UGC_FILTER_API = 'UGC_FILTER_API';

modExports.PKCE_CLIENT_ID = 'PKCE_CLIENT_ID';
modExports.PKCE_ENV = 'PKCE_ENV';
modExports.PKCE_PROFILE_HOST = 'PKCE_PROFILE_HOST';

modExports.VERSION = 'VERSION';

modExports.COURSE_TYPE_SKILL_BUILDER = 'Skill builder';
modExports.COURSE_TYPE_OUTCOMES_CAPABILITIES = 'Outcomes and capabilities';
modExports.COURSE_TYPE_CERT_PREP = 'Certification prep';
modExports.CART_LINK_URL = 'CART_LINK_URL';
modExports.CART_COUNT_URL = 'CART_COUNT_URL';

modExports.FILEMANAGER_PROXY_HOST = 'FILEMANAGER_PROXY_HOST';

modExports.COURSE_LEFT_NAV = ['Course overivew', 'Course outline', 'Teaching supplements', 'Announcements', 'Related learning'];
modExports.STANDALONE_MODULE_LEFT_NAV = ['Module overivew', 'Module downloads', 'Module outline', 'Teaching supplements', 'Announcements', 'Related learning'];

modExports.COMPANY_NAME = 'COMPANY_NAME';
modExports.COACHING_TYPE = 'COACHING_TYPE';
modExports.OBJECTIVES = 'OBJECTIVES';
modExports.AVAILABILITY = 'AVAILABILITY';
modExports.REQUEST_REVIEW = 'REQUEST_REVIEW';
modExports.PREMIUM_DESCRIPTION = 'PREMIUM_DESCRIPTION';
modExports.FAQ = 'FAQ';
modExports.FF_COACHING_REQUEST = 'FF_COACHING_REQUEST';
modExports.LEARN_LIVE_COACHING_REQUEST_SUBMIT_VERSION = 'LEARN_LIVE_COACHING_REQUEST_SUBMIT_VERSION';
modExports.COACHING_OVERVIEW_URL = 'COACHING_OVERVIEW_URL';
modExports.COACHING_SUBSCRIPTION_TYPE_MAP = { premium: { id: 1, label: 'Premium' }, enterprise: { id: 2, label: 'Enterprise' } };

modExports.APP_PROBLEM_EDITOR = 'problemEditor';

modExports.ENABLE_ADOBE_TARGET = 'ENABLE_ADOBE_TARGET';
modExports.DATA_SCIENCE_API_HOST = 'DATA_SCIENCE_API_HOST';
modExports.DATA_SCIENCE_XAPI_KEY = 'DATA_SCIENCE_XAPI_KEY';

modExports.AUTHENTICATION_HOST = 'AUTHENTICATION_HOST';
modExports.TWO_LEGGED_CLIENT_ID = 'TWO_LEGGED_CLIENT_ID';
modExports.TWO_LEGGED_CLIENT_SECRET = 'TWO_LEGGED_CLIENT_SECRET';
modExports.VIDEO_LOCALIZATION_HOST = 'VIDEO_LOCALIZATION_HOST';
modExports.VIDEO_LOCALIZATION_API_KEY = 'VIDEO_LOCALIZATION_API_KEY';

/*
 This object is a key/value list of AWS Lambda Environment Variables required for the application.
 The value of each key is an object that contains:
    default (required): default value for this key if it is not present in the env
    validator (optional): a function to validate the value before setting it.  This function should
    return a boolean value.  If false the application will use the default value instead of the value
    that failed validation.
 */
modExports.AWS_ENV_VARS = {
  ENVIRONMENT: {
    default: modExports.DEV_ENV,
    validator: (v) => modExports.VALID_AWS_ENVS.includes(v),
  },
  LOG_LEVEL: {
    default: modExports.LOG_LEVEL_ERROR,
    validator: (v) => modExports.VALID_LOG_LEVELS.includes(v),
  },
  HTML_MAX_AGE: {
    default: '86400',
    validator: (v) => RegExp(/^\d+$/).test(v),
  },
  LOGGER_URL: {},
};

/*
 This object contains Constants who's values are relative to the environment the application is running in.
 */
modExports.ENVIRONMENT_CONSTANTS = {
  dev: {
    ENVIRONMENT: modExports.DEV_ENV,
    LOG_LEVEL: 'debug',
    COURSE_API_HOST: 'https://app.gnosis-mfe-stg.autodesk.com',
    COURSE_PREVIEW_API_HOST:
      'https://7txzsfq1y9.execute-api.us-east-1.amazonaws.com',
    CONTENTFUL_GRAPHQL_HOST: 'https://graphql.contentful.com',
    CONTENTFUL_ENVIRONMENT_ID: 'master',
    CONTENTFUL_SPACE_ID: 'ooioaq2tbzyk',
    LL_PRODUCER_API: 'https://api.upskill-stg.autodesk.com/lrs/producer',
    LL_CONSUMER_API: 'https://api.upskill-stg.autodesk.com/lrs/consumer',
    LIST_API_HOST: 'https://app.gnosis-mfe-stg.autodesk.com/api/v1',
    SHARE_PREFIX: 'https://app.upskill-dev.autodesk.com',
    CLARUS_LINK: 'https://autodesk.clarus-stage.com',
    CERT_API:
      'https://api-credentialing-dev.autodesk.com/v1/certificate/generate',
    SEARCH_API: 'https://kp.services-stage.autodesk.com/service/rest/unifiedlearn/v1/search',
    FILTER_API: 'https://kp.services-stage.autodesk.com/service/rest/unifiedlearn/v1/filters',
    PKCE_CLIENT_ID: '4ty7y6VbGI1BGrHyrWHk5Wsf0VFgDAAY',
    PKCE_ENV: 'stg',
    PKCE_PROFILE_HOST: 'https://developer-stg.api.autodesk.com',
    ROUTER_BASENAME: '/learn',
    HTML_MAX_AGE: '86400',
    LEARN_LIVE_ENROLLMENT_HOST: 'https://learnlive-enrollment-api-dev.autodesk.com',
    LEARN_LIVE_COACHING_REQUEST_HOST: 'https://learnlive-coachingrequest-api-dev.autodesk.com',
    WTIH: {
      APPID: 'learnone',
      APIKEY: '9032533df48e4846ad0f6989e163343f',
      SECRET: 'b5d84be8-6b01-4093-adbd-aa89c24ee514',
    },
    CART_LINK_URL: 'https://checkout-pt.autodesk.com/en-US?visitorId={{visitorId}}',
    CART_COUNT_URL: 'https://amart.bicstg.autodesk.com/services/v5/cart/{{visitorId}}|STORE-NAMER/count',
    FILEMANAGER_PROXY_HOST: 'false',
    CLIENT_CONTEXT_CHANNEL: `${modExports.CLIENT_SOURCE_AEX},${modExports.CLIENT_SOURCE_CSO},${modExports.CLIENT_SOURCE_LRNO}`,
    UGC_FILTER_KEY: 'utQuGzFlg39ci8FyAsIVt6NDOdB4wADdaNb7lIKn',
    UGC_FILTER_API: 'https://offensive-detector-dev.ml.dhx.autodesk.com/v1/keywords',
    FF_COACHING_REQUEST: 'true',
    LEARN_LIVE_COACHING_REQUEST_SUBMIT_VERSION: 'v2',
    COACHING_OVERVIEW_URL: 'https://www-pt.autodesk.com/coaching/overview',
    APP_ACCOUNTS: 'https://accounts-dev.autodesk.com/',
    APP_PROFILE: 'https://profile-dev.autodesk.com/',
    ENABLE_ADOBE_TARGET: 'true',
    USER_PROFILE_API: 'https://api.userprofile-stg.autodesk.com/userprofile',
    DATA_SCIENCE_API_HOST: 'https://personalize-dev.ml.dhx.autodesk.com/v2/features',
    DATA_SCIENCE_XAPI_KEY: 'MNk4aTIlPt5dYqeMq2R0r47tfjvkTVVY3ze38EYR',
    AUTHENTICATION_HOST: 'https://developer-stg.api.autodesk.com/authentication/v2/token',
    TWO_LEGGED_CLIENT_ID: 'XL27GIJ8hjh9Sc8N7TjzHBmlB7TaWHqhGgu0yTCE0AzbrY0Q',
    VIDEO_LOCALIZATION_HOST: 'https://data-stg.beehive.autodesk.com/v1/get-video',
    VIDEO_LOCALIZATION_API_KEY: 'FNo8dd2Q7MalEIP8cgGps4B7r1ZyyCGS7wmiw9Va',
  },
  stg: {
    ENVIRONMENT: modExports.STAGE_ENV,
    LOG_LEVEL: 'warn',
    COURSE_API_HOST: 'https://www-pt.autodesk.com',
    COURSE_PREVIEW_API_HOST:
      'https://7txzsfq1y9.execute-api.us-east-1.amazonaws.com',
    CONTENTFUL_GRAPHQL_HOST: 'https://graphql.contentful.com',
    CONTENTFUL_ENVIRONMENT_ID: 'master',
    CONTENTFUL_SPACE_ID: 'ooioaq2tbzyk',
    LL_PRODUCER_API: 'https://api.upskill-stg.autodesk.com/lrs/producer',
    LL_CONSUMER_API: 'https://api.upskill-stg.autodesk.com/lrs/consumer',
    LIST_API_HOST: 'https://app.gnosis-mfe-stg.autodesk.com/api/v1',
    SHARE_PREFIX: 'https://app.upskill-stg.autodesk.com',
    CLARUS_LINK: 'https://autodesk.clarus-stage.com',
    CERT_API:
      'https://api-credentialing-staging.autodesk.com/v1/certificate/generate',
    SEARCH_API: 'https://kp.services-stage.autodesk.com/service/rest/unifiedlearn/v1/search',
    FILTER_API: 'https://kp.services-stage.autodesk.com/service/rest/unifiedlearn/v1/filters',
    PKCE_CLIENT_ID: '4ty7y6VbGI1BGrHyrWHk5Wsf0VFgDAAY',
    PKCE_ENV: 'stg',
    PKCE_PROFILE_HOST: 'https://developer-stg.api.autodesk.com',
    ROUTER_BASENAME: '/learn',
    HTML_MAX_AGE: '86400',
    LEARN_LIVE_ENROLLMENT_HOST: 'https://learnlive-enrollment-api-stg.autodesk.com',
    LEARN_LIVE_COACHING_REQUEST_HOST: 'https://learnlive-coachingrequest-api-stg.autodesk.com',
    WTIH: {
      APPID: 'learnone',
      APIKEY: 'b88de4ab67cc4f3eb630de893ef408db',
      SECRET: 'b5d84be8-6b01-4093-adbd-aa89c24ee514',
    },
    CART_LINK_URL: 'https://checkout-pt.autodesk.com/en-US?visitorId={{visitorId}}',
    CART_COUNT_URL: 'https://amart.bicstg.autodesk.com/services/v5/cart/{{visitorId}}|STORE-NAMER/count',
    FILEMANAGER_PROXY_HOST: 'false',
    CLIENT_CONTEXT_CHANNEL: `${modExports.CLIENT_SOURCE_AEX},${modExports.CLIENT_SOURCE_CSO},${modExports.CLIENT_SOURCE_LRNO}`,
    UGC_FILTER_KEY: 'XCkLp9ufSXUC7d0dCAxQzT809RfoU52SQfwbdwj0',
    UGC_FILTER_API: 'https://offensive-detector-stg.ml.dhx.autodesk.com/v1/keywords',
    FF_COACHING_REQUEST: 'true',
    LEARN_LIVE_COACHING_REQUEST_SUBMIT_VERSION: 'v2',
    COACHING_OVERVIEW_URL: 'https://www-pt.autodesk.com/coaching/overview',
    APP_ACCOUNTS: 'https://accounts-staging.autodesk.com/',
    APP_PROFILE: 'https://profile-stg.autodesk.com/',
    ENABLE_ADOBE_TARGET: 'true',
    USER_PROFILE_API: 'https://api.userprofile-stg.autodesk.com/userprofile',
    DATA_SCIENCE_API_HOST: 'https://personalize-stg.ml.dhx.autodesk.com/v2/features',
    DATA_SCIENCE_XAPI_KEY: 'IeR6c9xnMU6hdq7EPH9rY5SyBNsmNJLl7omAzMGE',
    AUTHENTICATION_HOST: 'https://developer-stg.api.autodesk.com/authentication/v2/token',
    TWO_LEGGED_CLIENT_ID: 'XL27GIJ8hjh9Sc8N7TjzHBmlB7TaWHqhGgu0yTCE0AzbrY0Q',
    VIDEO_LOCALIZATION_HOST: 'https://data-stg.beehive.autodesk.com/v1/get-video',
    VIDEO_LOCALIZATION_API_KEY: 'FNo8dd2Q7MalEIP8cgGps4B7r1ZyyCGS7wmiw9Va',
  },
  prod: {
    ENVIRONMENT: modExports.PROD_ENV,
    LOG_LEVEL: 'error',
    COURSE_API_HOST: 'https://www.autodesk.com',
    COURSE_PREVIEW_API_HOST:
      'https://7txzsfq1y9.execute-api.us-east-1.amazonaws.com',
    CONTENTFUL_GRAPHQL_HOST: 'https://graphql.contentful.com',
    CONTENTFUL_ENVIRONMENT_ID: 'master',
    CONTENTFUL_SPACE_ID: 'ooioaq2tbzyk',
    LL_PRODUCER_API: 'https://api.upskill.autodesk.com/lrs/producer',
    LL_CONSUMER_API: 'https://api.upskill.autodesk.com/lrs/consumer',
    CLARUS_LINK: 'https://autodesk.useclarus.com',
    CERT_API: 'https://api-credentialing.autodesk.com/v1/certificate/generate',
    SEARCH_API: 'https://kp.services.autodesk.com/service/rest/unifiedlearn/v1/search',
    FILTER_API: 'https://kp.services.autodesk.com/service/rest/unifiedlearn/v1/filters',
    LIST_API_HOST: 'https://app.gnosis-mfe.autodesk.com/api/v1',
    PKCE_CLIENT_ID: 'Zk2dzV3DhtuoJs2q9bTAf5oyUir3lMuG',
    PKCE_ENV: 'prod',
    PKCE_PROFILE_HOST: 'https://developer.api.autodesk.com',
    ROUTER_BASENAME: '/learn',
    HTML_MAX_AGE: '86400',
    LEARN_LIVE_ENROLLMENT_HOST: 'https://learnlive-enrollment-api.autodesk.com',
    LEARN_LIVE_COACHING_REQUEST_HOST: 'https://learnlive-coachingrequest-api.autodesk.com',
    WTIH: {
      APPID: 'learnone',
      APIKEY: '69b38b6ef8894ef08d2fc5409933cc3d',
      SECRET: '8e22077f-0f3e-f892-b948-a942275fe856',
    },
    CART_LINK_URL: 'https://checkout.autodesk.com/en-US?visitorId={{visitorId}}',
    CART_COUNT_URL: 'https://amart.oc.autodesk.com/services/v5/cart/{{visitorId}}|STORE-NAMER/count',
    FILEMANAGER_PROXY_HOST: 'false',
    CLIENT_CONTEXT_CHANNEL: `${modExports.CLIENT_SOURCE_AEX},${modExports.CLIENT_SOURCE_CSO},${modExports.CLIENT_SOURCE_LRNO}`,
    UGC_FILTER_KEY: 'myQBpk3JUj3Yb45a63UO1aFQNZg8JOD26PMl0Xs2',
    UGC_FILTER_API: 'https://offensive-detector.ml.dhx.autodesk.com/v1/keywords',
    FF_COACHING_REQUEST: 'false',
    LEARN_LIVE_COACHING_REQUEST_SUBMIT_VERSION: 'v2',
    COACHING_OVERVIEW_URL: 'https://www.autodesk.com/coaching/overview',
    APP_ACCOUNTS: 'https://accounts.autodesk.com/',
    APP_PROFILE: 'https://profile.autodesk.com/',
    ENABLE_ADOBE_TARGET: 'true',
    USER_PROFILE_API: 'https://api.userprofile.autodesk.com/userprofile',
    DATA_SCIENCE_API_HOST: 'https://personalize.ml.dhx.autodesk.com/v2/features',
    DATA_SCIENCE_XAPI_KEY: 'GcT3DC1gpp8jMxmSPBP8l4C5BmbY3Rzi3NpebSRu',
    AUTHENTICATION_HOST: 'https://developer.api.autodesk.com/authentication/v2/token',
    TWO_LEGGED_CLIENT_ID: '3FxfA8aGTG51TO9roX0TKhHZ3zmltlqVKu7PfaUO9SWLKQty',
    VIDEO_LOCALIZATION_HOST: 'https://micro.beehive.autodesk.com/v1/get-video',
    VIDEO_LOCALIZATION_API_KEY: '6qqER0v02o92CGWPUDrVdEfa87f2uQ4D6QbCUH30',
  },
  perf: {
    ENVIRONMENT: modExports.PROD_ENV,
    LOG_LEVEL: 'error',
    COURSE_API_HOST: 'https://www.upskill-perf.autodesk.com',
    COURSE_PREVIEW_API_HOST:
      'https://7txzsfq1y9.execute-api.us-east-1.amazonaws.com',
    CONTENTFUL_GRAPHQL_HOST: 'https://graphql.contentful.com',
    CONTENTFUL_ENVIRONMENT_ID: 'master',
    CONTENTFUL_SPACE_ID: 'ooioaq2tbzyk',
    LL_PRODUCER_API: 'https://api.upskill-stg.autodesk.com/lrs/producer',
    LL_CONSUMER_API: 'https://api.upskill-stg.autodesk.com/lrs/consumer',
    SHARE_PREFIX: 'https://app.upskill-stg.autodesk.com',
    CLARUS_LINK: 'https://autodesk.clarus-stage.com',
    CERT_API:
      'https://jjsdqpcjfd.execute-api.us-west-1.amazonaws.com/convert-html-to-pdf',
    SEARCH_API: 'https://kp.services-stage.autodesk.com/community/service/rest/credential/v1/search',
    FILTER_API: 'https://kp.services-stage.autodesk.com/community/service/rest/credential/v1/filters',
    PKCE_CLIENT_ID: '4ty7y6VbGI1BGrHyrWHk5Wsf0VFgDAAY',
    PKCE_ENV: 'stg',
    PKCE_PROFILE_HOST: 'https://developer-stg.api.autodesk.com',
    ROUTER_BASENAME: '/learn',
    HTML_MAX_AGE: '86400',
    LEARN_LIVE_ENROLLMENT_HOST: 'https://learnlive-enrollment-api-dev.autodesk.com',
    LEARN_LIVE_COACHING_REQUEST_HOST: 'https://learnlive-coachingrequest-api-dev.autodesk.com',
    CART_LINK_URL: 'https://checkout-pt.autodesk.com/en-US?visitorId={{visitorId}}',
    CART_COUNT_URL: 'https://amart.bicstg.autodesk.com/services/v5/cart/{{visitorId}}|STORE-NAMER/count',
    FILEMANAGER_PROXY_HOST: 'false',
    FF_COACHING_REQUEST: 'true',
    LEARN_LIVE_COACHING_REQUEST_SUBMIT_VERSION: 'v2',
    COACHING_OVERVIEW_URL: 'https://www-pt.autodesk.com/coaching/overview',
    APP_ACCOUNTS: 'https://accounts.autodesk.com/',
    APP_PROFILE: 'https://profile.autodesk.com/',
    AUTHENTICATION_HOST: 'https://developer-stg.api.autodesk.com/authentication/v2/token',
    TWO_LEGGED_CLIENT_ID: 'XL27GIJ8hjh9Sc8N7TjzHBmlB7TaWHqhGgu0yTCE0AzbrY0Q',
    VIDEO_LOCALIZATION_HOST: 'https://data-stg.beehive.autodesk.com/v1/get-video',
    VIDEO_LOCALIZATION_API_KEY: 'FNo8dd2Q7MalEIP8cgGps4B7r1ZyyCGS7wmiw9Va',
  },
};

// Add ENVIRONMENT_CONSTANTS to AWS_ENV_VARS to allow for overrides
Object.keys(modExports.ENVIRONMENT_CONSTANTS.dev).forEach((key) => {
  modExports.AWS_ENV_VARS[key] = modExports.AWS_ENV_VARS[key] || {};
});

modExports.curatedSliceInitialState = {
  data: {},
  isLoaderVisible: true,
  isCongratsVisible: true,
  problemPassValue: 75,
};
modExports.curatedSliceName = 'curatedData';

modExports.tutorialSliceInitialState = {
  data: {},
  isLoaderVisible: true,
  problemPassValue: 75,
  isTutorialCompleted: false,
};
modExports.tutorialSliceName = 'tutorialData';

modExports.collectionSliceInitialState = {
  data: {},
  isLoaderVisible: false,
};
modExports.collectionSliceName = 'collectionData';

modExports.styleVariables = {
  background: lightTheme.tokens.colors.background,
  backgroundPanelColor: lightTheme.tokens.colors['background-panel'],
  inkOnBackground: lightTheme.tokens.colors['ink-on-background'],
  inkOnBackground60: lightTheme.tokens.colors['ink-on-background-60'],
  inkOnBackgroundDisabled: lightTheme.tokens.colors['ink-on-background-disabled'],
  inkSuccess: lightTheme.tokens.colors['ink-success'],
  fillWarning: lightTheme.tokens.colors['fill-warning'],
  divider: lightTheme.tokens.colors['ink-on-background-60'],
  lightDivider: lightTheme.tokens.colors['divider-0'],
  fontPrimary: lightTheme.tokens.typography['body-copy-medium'].fontFamily,
  fillSuccess: lightTheme.tokens.colors['fill-success'],
  fillSuccessSlight: lightTheme.tokens.colors['fill-success-slight'],
  fillError: lightTheme.tokens.colors['fill-error'],
  fillEngage: lightTheme.tokens.colors['fill-engage'],
  fillPrimary: lightTheme.tokens.colors['ink-on-fill-primary'],
  container0BoxShadow: lightTheme.tokens.effects['container-0'].boxShadow,
  detail1Opaque: lightTheme.tokens.colors['detail-1-opaque'],
  divider0BottomBoxShadow: lightTheme.tokens.effects['divider-0-bottom'].boxShadow,
  buttonOutlinedFocusBoxShadow: lightTheme.tokens.effects['focus-ring'].boxShadow,
  elevation0PopoverBoxShadow: lightTheme.tokens.effects['elevation-0-popover'].boxShadow,
};

modExports.catalogSliceInitialState = {
  path: {},
  result: {
    page: 1,
  },
  pagesShown: { tutorial: [1], curated: [1] },
  isLoaderVisible: true,
};
modExports.catalogSliceName = 'catalogData';

modExports.iconMap = {
  zip: FileZipIcon,
  doc: FileDocIcon,
  docx: FileDocIcon,
  pdf: FilePDFIcon,
  generic: FileGenericIcon,
};

modExports.LEARN_MFE = 'Learn MFE';

module.exports = modExports;
